/**
 * 将文件字节数转换为可读格式
 * @param bytes 文件字节数
 * @param decimals 保留小数位数，默认2位
 * @returns 格式化后的文件大小字符串
 */
export function formatFileSize(bytes: number, decimals = 2): string {
  if (bytes === 0) return '0 B';
  if (!bytes || isNaN(bytes) || bytes < 0) return '-';

  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return (
    parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + ' ' + sizes[i]
  );
}

/**
 * 精确格式化，根据大小自动调整单位
 * @param bytes 文件字节数
 * @returns 格式化后的文件大小字符串
 */
export function formatFileSizePrecise(bytes: number): string {
  if (bytes === 0) return '0 B';
  if (!bytes || isNaN(bytes) || bytes < 0) return '-';

  const units = [
    { unit: 'B', threshold: 1024 },
    { unit: 'KB', threshold: 1024 * 1024 },
    { unit: 'MB', threshold: 1024 * 1024 * 1024 },
    { unit: 'GB', threshold: 1024 * 1024 * 1024 * 1024 },
    { unit: 'TB', threshold: Infinity },
  ];

  const unit =
    units.find((u) => bytes < u.threshold) || units[units.length - 1];
  const value = bytes / (units[units.indexOf(unit) - 1]?.threshold || 1);

  return value.toFixed(unit.unit === 'B' ? 0 : 2) + ' ' + unit.unit;
}
